import {connect} from 'react-redux';
import ReferencesStepView from '../../../components/views/mx/creditoReal/ReferencesStepView';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import {withRouter} from 'react-router';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';

const mapStateToProps = (state, {match}) => {
    const summaryStepView = state.creditoReal.ui.summaryStepView;
    return {
        otherReferences: state.creditoReal.loanApplication.otherReferences,
        loanApplicationToken: match.params.token,
        returnToSummary: summaryStepView.returnToSummary
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeOtherReferences: otherReferences =>
            dispatch(WizardActions.CHANGE_OTHER_REFERENCES_ACTION.action(otherReferences)),
        onPressNext: () => {
            pushDataLayer(DATA_LAYER.REFERENCES);
            dispatch(WizardMXActions.SAVE_OTHER_REFERENCES_MX_ACTION.action());
        },
        onPressBack: () => dispatch(WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.action()),
        getLoanApplication: token => () =>
            dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token))
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        getLoanApplication: dispatchProps.getLoanApplication(stateProps.loanApplicationToken)
    };
};

const ReferencesStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ReferencesStepView));

export default ReferencesStepContainer;